/* global axios */
import ApiClient from './ApiClient';

class BillingAPI extends ApiClient {
  constructor() {
    super('billing', { accountScoped: true });
  }

  getOverview() {
    return axios.get(this.url);
  }

  getEntitlements() {
    return axios.get(`${this.url}/entitlements`);
  }

  updateProfile(profile) {
    return axios.patch(`${this.url}/profile`, { profile });
  }

  createPaymentMethod(paymentMethod) {
    return axios.post(`${this.url}/payment_methods`, {
      payment_method: paymentMethod,
    });
  }

  tokenizeCreditCard({ creditCard, holderInfo, defaultMethod = true }) {
    return axios.post(`${this.url}/payment_methods/tokenize_credit_card`, {
      credit_card: creditCard,
      holder_info: holderInfo,
      default: defaultMethod,
    });
  }

  createCharge(payload) {
    return axios.post(`${this.url}/charges`, payload);
  }

  createAiCharge(payload) {
    return axios.post(`${this.url}/ai_charges`, payload);
  }

  submitEnterpriseInterest(enterpriseInterest) {
    return axios.post(`${this.url}/enterprise_interest`, {
      enterprise_interest: enterpriseInterest,
    });
  }

  submitPlanChangeRequest(planChangeRequest) {
    return axios.post(`${this.url}/plan_change_request`, {
      plan_change_request: planChangeRequest,
    });
  }

  submitAiPlanChangeRequest(aiPlanChangeRequest) {
    return axios.post(`${this.url}/ai_plan_change_request`, {
      ai_plan_change_request: aiPlanChangeRequest,
    });
  }

  cancelPlatformPlan(reason) {
    return axios.post(`${this.url}/cancel_platform_plan`, { reason });
  }

  undoPlatformCancellation() {
    return axios.post(`${this.url}/undo_platform_cancellation`);
  }

  cancelAiPlan(reason) {
    return axios.post(`${this.url}/cancel_ai_plan`, { reason });
  }

  undoAiCancellation() {
    return axios.post(`${this.url}/undo_ai_cancellation`);
  }
}

export default new BillingAPI();
